import API from "../../../api/index";
import { useState, useEffect } from "react";
import { Stack, Box, Typography, Skeleton } from "@mui/material";
import { boxStyle } from "../../../theme";
import CircleIcon from "@mui/icons-material/Circle";
import SensorsIcon from "@mui/icons-material/Sensors";

const OnlineCard = () => {
  const [online, setOnline] = useState(null);
  const [probeMode, setProbeMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController()
    API.getLecsStatus(controller.signal).then((response) => {

      setOnline(response.data.state);

    }).catch((err) => {
      if (err.name !== 'CanceledError') setOnline("Offline");
    }).finally(() => setLoading(false));
    return () => controller.abort()
  }, []);

  useEffect(() => {
    const controller = new AbortController()
    API.getConfig({ type: "probe" }, controller.signal).then((res) => {
      sessionStorage.setItem("probeMode", res?.data?.config ?? false);
      setProbeMode(res?.data?.config ?? false);
    }).catch((err) => {
      if (err.name !== 'CanceledError') setProbeMode(false);
    });
    return () => controller.abort()
  }, []);

  const lecsColor = online === "Online" ? "#78d168" : online === "Backup" ? "orange" : "#931a1d";

  return (
    <Box sx={{ ...boxStyle, display: "flex", flexDirection: "column" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888" }}>
          Device Status
        </Typography>
        <Box
          sx={{
            width: 36, height: 36, borderRadius: "10px",
            backgroundColor: "rgba(255, 255, 255, 0.06)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <SensorsIcon sx={{ fontSize: 18, color: "#888" }} />
        </Box>
      </Stack>

      {loading ? (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="75%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.08)" }} />
          <Skeleton variant="rounded" width="60%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.08)" }} />
        </Stack>
      ) : (
        <Stack spacing={1}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <CircleIcon sx={{ fontSize: 10, color: lecsColor }} />
            <Typography sx={{ fontSize: 14 }}>LECS {online}</Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <CircleIcon sx={{ fontSize: 10, color: probeMode ? "#78d168" : "#555" }} />
            <Typography sx={{ fontSize: 14 }}>
              Probe mode: {probeMode === false ? "OFF" : "ON"}
            </Typography>
          </Stack>
        </Stack>
      )}

      <Typography sx={{ fontSize: 12, color: "#555", marginTop: "auto", paddingTop: 1 }}>
        Online devices and probe mode
      </Typography>
    </Box>
  );
};

export default OnlineCard;
